module.exports = __webpack_public_path__ + "img/logo.a704c41d.png";